import * as React from 'react';
import { FieldWrapper } from '@progress/kendo-react-form';
import ColorPicker from 'shared/inputs/ColorPicker';
// eslint-disable-next-line no-unused-vars
import BaseFormControl from './BaseFormControl';
import { Label, Error, Hint } from '@progress/kendo-react-labels';

/**
 *  A color picker form field.
 *
 * @typedef {React.ComponentProps<BaseFormControl>} BaseFieldRenderProps
 * @typedef {React.ComponentProps<ColorPicker>} ColorPickerProps
 *
 * @param {BaseFieldRenderProps & ColorPickerProps} fieldRenderProps Field render props
 * @returns {React.ReactElement} Form color picker
 */
export const FormColorPicker = (fieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    name,
    valid,
    disabled,
    hint,
    wrapperStyle,
    ...others
  } = fieldRenderProps;

  const editorId = id ?? name;

  const editorRef = React.useRef(null);
  const showValidationMessage = touched && validationMessage;
  const showHint = !showValidationMessage && hint;
  const hintId = showHint ? `${editorId}_hint` : '';
  const errorId = showValidationMessage ? `${editorId}_error` : '';
  const labelId = label ? `${editorId}_label` : '';

  return (
    <FieldWrapper style={wrapperStyle}>
      <Label id={labelId} editorRef={editorRef} editorId={editorId} editorValid={valid} editorDisabled={disabled}>
        {label}
      </Label>
      <span data-testid={editorId}>
        <ColorPicker
          ariaLabelledBy={labelId}
          ariaDescribedBy={`${hintId} ${errorId}`}
          ref={editorRef}
          valid={valid}
          id={editorId}
          disabled={disabled}
          name={name}
          {...others}
        />
      </span>
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};